import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { ConfigProvider } from 'antd'
import NotExist from './components/NotExist'
import { initializeApp } from 'firebase/app'
// import { getAnalytics } from 'firebase/analytics'
import { firebaseConfig } from './config/firebaseConfig'
import { httpsCallable } from 'firebase/functions'
import Promotion from './components/Promotion'
import './App.css'
import { theme } from './config/theme'
import Landing from './components/Landing'
import Home from './components/Home'
import CandlePens from './components/CandlePens'
import CandlePensIngredients from './components/CandlePensIngredients'
import CookieConsentBanner from './components/CookieConsentBanner'
import LegalNotice from './components/LegalNotice'
import PrivacyPolicy from './components/PrivacyPolicy'
import OnlineCourse from './components/OnlineCourse'
import { courses } from './data/courses'
import { AuthProvider } from './contexts/AuthContext'
import AuthPage from './components/AuthPage'
import ProtectedRoute from './components/ProtectedRoute'
import CourseProtectedRoute from './components/CourseProtectedRoute'
import StitchRedesignPreview from './components/StitchRedesignPreview'
import HomePreview from './components/HomePreview'
import LandingPreview from './components/LandingPreview'

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)
const functions = getFunctions(firebaseApp, 'europe-west1')

// Get Analytics instance
// const analytics = getAnalytics(firebaseApp)
// console.log('analytics', analytics)

if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
}

export { functions }

export const sendEmailFunc = httpsCallable(functions, 'sendEmailFunc')

const AppRoutes = () => {
  const location = useLocation()
  const showCookieBanner = ![ '/preview', '/home_preview', '/landing_preview' ].includes(location.pathname)

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/candle-pens" element={<CandlePens />} />
        <Route path="/candle-pens-ingredients" element={<CandlePensIngredients />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/legal-notice" element={<LegalNotice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/preview" element={<StitchRedesignPreview />} />
        <Route path="/home_preview" element={<HomePreview />} />
        <Route path="/landing_preview" element={<LandingPreview />} />
        {/* Dynamic course routes */}
        {Object.values(courses).map(course => (
          <Route
            key={course.id}
            path={`/${course.routePath}`}
            element={
              <CourseProtectedRoute courseId={course.id}>
                <OnlineCourse course={course} />
              </CourseProtectedRoute>
            }
          />
        ))}
        <Route path="*" element={<NotExist />} />
      </Routes>
      {showCookieBanner && <CookieConsentBanner />}
    </>
  )
}

const App = () => {
  return (
    <ConfigProvider
      theme={theme}
    >
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  )
}

export default App
